import { ReportesService } from './../../../../services/reportes.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { take } from 'rxjs';
import moment from 'moment';


interface Food {
    value: string;
    viewValue: string;
}

export interface PeriodicElement {
    fechaIngreso: Date;
    folioInicial: string;
    folioFinal: string;
    total: number;
    utilizados: number;
    asignados: number;
    disponibles: number;
    anulados: number;
    fechaVencimiento: Date;
    estado: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
    {
        fechaIngreso: new Date(2022, 6, 22),
        folioInicial: '20635165165',
        folioFinal: '20635165165',
        total: 100,
        utilizados: 100,
        asignados: 100,
        disponibles: 100,
        anulados: 100,
        fechaVencimiento: new Date(2022, 7, 22),
        estado: 'VIGENTE',
    },
    {
        fechaIngreso: new Date(2022, 6, 22),
        folioInicial: '20635165165',
        folioFinal: '20635165165',
        total: 100,
        utilizados: 100,
        asignados: 100,
        disponibles: 100,
        anulados: 100,
        fechaVencimiento: new Date(2022, 7, 22),
        estado: 'UTILIZADO',
    },
    {
        fechaIngreso: new Date(2022, 6, 22),
        folioInicial: '20635165165',
        folioFinal: '20635165165',
        total: 100,
        utilizados: 100,
        asignados: 100,
        disponibles: 100,
        anulados: 100,
        fechaVencimiento: new Date(2022, 7, 22),
        estado: 'UTILIZADO',
    },
    {
        fechaIngreso: new Date(2022, 6, 22),
        folioInicial: '20635165165',
        folioFinal: '20635165165',
        total: 100,
        utilizados: 100,
        asignados: 100,
        disponibles: 100,
        anulados: 100,
        fechaVencimiento: new Date(2022, 7, 22),
        estado: 'VENCIDO',
    },
];
@Component({
    selector: 'reporte-folios',
    templateUrl: './reporte-folios.component.html',
    encapsulation: ViewEncapsulation.None,

})
export class ReporteFoliosComponent {
    constructor(private route: Router, private _ReportesService: ReportesService) { }
    selected = '1';

    foods: Food[] = [
        { value: '1', viewValue: 'Seleccione' },
        { value: '2', viewValue: 'En proceso' },
        { value: '3', viewValue: 'Pagado' },
    ];

    date = new FormControl(new Date());

    documentos: string[] = [
        'Pagaré',
        'Pagaré Notariado',
        'Factura',
        'Factura',
        'Contrato',
        'Otros',
        'Otros',
        'Otros',
    ];

    columns: TableColumn[] = [

        {
            columnDef: 'fechaIngreso',
            header: 'FECHA INGRESO',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "date",
            columnFormat: "dd/MM/YYYY",
            columnSort: true
        },
        {
            columnDef: 'folioInicial',
            header: 'FOLIO INICIAL',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "string",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'folioFinal',
            header: 'FOLIO FINAL',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "string",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'total',
            header: 'TOTAL',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "number",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'utilizados',
            header: 'CANT. FOLIOS UTILIZADOS',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "number",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'asignados',
            header: 'ÚLT. FOLIO ASIGNADO',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "number",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'disponibles',
            header: 'CANT. FOLIOS DISPONIBLES',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "number",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'anulados',
            header: 'CANT. FOLIOS ANULADOS',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "number",
            columnFormat: "",
            columnSort: true
        },
        {
            columnDef: 'fechaVencimiento',
            header: 'FECHA VENCIMIENTO',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "date",
            columnFormat: "dd/MM/YYYY",
            columnSort: true
        },
        {
            columnDef: 'estado',
            header: 'ESTADO',
            headerClass: "text-center px-1.5",
            columnClass: "px-1.5 paragraph-5 text-center",
            columnType: "custom",
            columnFormat: "",
            columnSort: true,
            columFunction: this.printEstado
        },

    ]

    displayedColumns: string[] = [
        'fechaIngreso',
        'folioInicial',
        'folioFinal',
        'total',
        'utilizados',
        'asignados',
        'disponibles',
        'anulados',
        'fechaVencimiento',
        'estado',
    ];

    dataSource: any[] = [];
    start: moment.Moment = moment().add(-30, 'd');
    end: moment.Moment = moment().add(0, 'd');

    goback(): void {
        this.route.navigateByUrl('home/reportes');
    }

    selection = new SelectionModel<any>(true, []);

    ngOnInit() {
        let start = this.start.format('yyyy-MM-DD');
        let end = this.end.format('yyyy-MM-DD');
        this._ReportesService
            .rangoFechaFolio(start, end)
            .pipe(take(1))
            .subscribe({
                next: (folio) => {
                    this.dataSource = folio.map((elem) => ({
                        fechaIngreso: elem.FECHA_INGRESO,
                        folioInicial: elem.FOLIO_INICIAL,
                        folioFinal: elem.FOLIO_FINAL,
                        total: elem.TOTAL,
                        anulados: elem.ANULADOS,
                        fechaVencimiento: elem.FECHA_VENCIMIENTO,
                        disponibles: elem.DISPONIBLES,
                        utilizados: elem.EN_USO,
                        estado: elem.ID_ESTADO,
                        asignados: elem.FOLIO_INICIAL + elem.EN_USO + elem.ANULADOS - 1
                    }));
                    //console.log(this.dataSource);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => { },
            });

        /* 
        Se agregan atributos solo como muestra.
        */
        let dates = [
            new Date(2022, 7, 1),
            new Date(2022, 7, 2),
            new Date(2022, 7, 3),
            new Date(2022, 7, 4),
            new Date(2022, 0, 1, 23),
            new Date(2022, 2, 2),
            new Date(2022, 3, 3),
            new Date(2022, 4, 4),
            new Date(2020, 7, 1),
            new Date(2020, 7, 2),
        ]

        let estados = [
            'OTRO',
            'EMITIDO',
            'NOTARIADO',
            'EMITIDO',
            'NOTARIADO',
            'EMITIDO',
            'NOTARIADO',
            'NOTARIADO',
            'EMITIDO',
            'EMITIDO',
        ]
        /* Asignacion del dataSource, el map es solo para agregar atributos de ejemplo de otros tipos de datos */
        //this.dataSource = ELEMENT_DATA.map((m,i) => ({ ...m ,fechaIngreso:dates[i]}))

    }

    onTableAction(row: any) {
        console.log('ver detalles de', row)
    }


    ejemploBorrarSeleccionados() {
        // console.log(this.selection.selected);
        this.dataSource = this.dataSource.filter(f => !this.selection.selected.some(s => s.position == f.position));
        this.selection = new SelectionModel<any>(true, []);
    }
    dateRangeChange($event: any, dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        // console.log('event', $event);
        // console.log('view start', dateRangeStart.value);
        //console.log('view end', dateRangeEnd.value);
        if (this.start && this.end) {
            let start = this.start.format('yyyy-MM-DD');
            let end = this.end.format('yyyy-MM-DD');
            this._ReportesService
                .rangoFechaFolio(start, end)
                .pipe(take(1))
                .subscribe({
                    next: (folio) => {
                        this.dataSource = folio.map((elem) => ({
                            fechaIngreso: elem.FECHA_INGRESO,
                            folioInicial: elem.FOLIO_INICIAL,
                            folioFinal: elem.FOLIO_FINAL,
                            total: elem.TOTAL,
                            anulados: elem.ANULADOS,
                            fechaVencimiento: elem.FECHA_VENCIMIENTO,
                            disponibles: elem.DISPONIBLES,
                            utilizados: elem.EN_USO,
                            estado: elem.ID_ESTADO,
                            asignados: elem.FOLIO_INICIAL + elem.EN_USO + elem.ANULADOS - 1
                        }));
                    },
                    error: (err) => {
                        console.log(err);
                    },
                    complete: () => { },
                })
        }

    }

    printEstado(row: any, attribute: string): string {
        let dict = {
            1: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    VIGENTE
                    </p>
                </div>
            </div>`,
            4: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    VENCIDO
                    </p>
                </div>
            </div>`,
            3: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
            2: `
            <div class="flex justify-start">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-02">
                    <p class="paragraph-tag_upper text-primary-white-01">
                    EN USO
                    </p>
                </div>
            </div>`,

        }
        return dict[row[attribute]] || "";
    }

    printEstadoMobile(attribute: string): string {
        let dict = {
            1: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-04">
                    <p class="paragraph-tag_upper text-primary-green-01">
                    VIGENTE
                    </p>
                </div>
            </div>`,
            4: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-pink-01">
                    <p class="paragraph-tag_upper text-primary">
                    VENCIDO
                    </p>
                </div>
            </div>`,
            3: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-gray-02">
                    <p class="paragraph-tag_upper text-primary-gray-01">
                    UTILIZADO
                    </p>
                </div>
            </div>`,
            2: `
            <div class="flex justify-center">
                <div class="rounded-full flex justify-center w-26 h-6 items-center bg-primary-green-02">
                    <p class="paragraph-tag_upper text-primary-white-01">
                    EN USO
                    </p>
                </div>
            </div>`

        }
        return dict[attribute] || "";
    }
}
